import React from "react";

const AppIcon = ({ height = 24, width = 24, color = "#000" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.324 1.51746C16 1.50004 16 1.50004 16.676 1.51746H28C28.4072 1.75702 28.6573 2.19422 28.6573 2.66671V29.3334C28.6573 29.8059 28.4072 30.2431 28 30.4826H16.676C16 30.5 16 30.5 15.324 30.4826H3.99064C3.58339 30.2431 3.33334 29.8059 3.33334 29.3334L3.33334 2.66671C3.33334 2.19422 3.58339 1.75702 3.99064 1.51746L15.324 1.51746ZM6 4.21362V27.7865H16H26.5V4.21362H16H6Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 10.6667C22.0697 10.6667 22.6667 11.2637 22.6667 12.0001V20.0001C22.6667 20.7365 22.0697 21.3334 21.3333 21.3334C20.597 21.3334 20 20.7365 20 20.0001V12.0001C20 11.2637 20.597 10.6667 21.3333 10.6667ZM16 13.3334C16.7364 13.3334 17.3333 13.9304 17.3333 14.6667V20.0001C17.3333 20.7365 16.7364 21.3334 16 21.3334C15.2636 21.3334 14.6667 20.7365 14.6667 20.0001V14.6667C14.6667 13.9304 15.2636 13.3334 16 13.3334ZM10.6667 16.0001C11.403 16.0001 12 16.597 12 17.3334V20.0001C12 20.7365 11.403 21.3334 10.6667 21.3334C9.93029 21.3334 9.33334 20.7365 9.33334 20.0001V17.3334C9.33334 16.597 9.93029 16.0001 10.6667 16.0001Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default AppIcon;
